'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('../../style/index.css');

require('../../style/icon.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactComponents = require('@cimpress/react-components');

var _refererUtils = require('../tools/refererUtils');

var _refererUtils2 = _interopRequireDefault(_refererUtils);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentRefererIcon = function (_React$Component) {
    _inherits(CommentRefererIcon, _React$Component);

    function CommentRefererIcon() {
        _classCallCheck(this, CommentRefererIcon);

        return _possibleConstructorReturn(this, (CommentRefererIcon.__proto__ || Object.getPrototypeOf(CommentRefererIcon)).apply(this, arguments));
    }

    _createClass(CommentRefererIcon, [{
        key: 'render',
        value: function render() {
            var referer = this.props.referer;

            if (!referer || !_refererUtils2.default.isCimpressDomain(referer)) {
                return null;
            }

            var originatesHere = _url2.default.parse(window.location.href).host === _url2.default.parse(referer).host;
            var iconClass = originatesHere ? 'home' : 'map-marker';
            var label = originatesHere ? _react2.default.createElement(
                'span',
                null,
                'Comment created in this UI'
            ) : _react2.default.createElement(
                'span',
                null,
                'Comment created at',
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'a',
                    null,
                    _refererUtils2.default.makeIntoLabel(referer)
                ),
                _react2.default.createElement('br', null),
                'Click the icon to follow the link.'
            );

            var icon = _react2.default.createElement('div', { className: 'comment-header-icon fa fa-' + iconClass });

            return _react2.default.createElement(
                'a',
                { href: referer, target: '_blank', rel: 'noopener noreferrer' },
                _react2.default.createElement(
                    _reactComponents.Tooltip,
                    {
                        direction: 'top',
                        contents: label,
                        className: 'rcc-tooltip-wide' },
                    icon
                )
            );
        }
    }]);

    return CommentRefererIcon;
}(_react2.default.Component);

CommentRefererIcon.propTypes = {
    referer: _propTypes2.default.string
};

exports.default = CommentRefererIcon;